module.exports = __webpack_public_path__ + "img/off_etiquetadora.c4a9df49.png";